<script setup>
import { onMounted, ref } from "vue";
import Sidebar from "./Sidebar.vue";
import { useI18n } from "vue-i18n";
import { MagicIcon } from "@Icons/index";
import AppLink from "@Components/AppLink.vue";
import { PrimaryButton } from "@Components/Button";
import { ArrowRightIcon, HistoryIcon } from "lucide-vue-next";
import { useForm } from "@/form";

const { t: __ } = useI18n();

const projects = ref([]);
const loaded = ref(false);

onMounted(async () => {
    projects.value = await useForm({
        limit: 10,
    }).post("projects_latest");
    loaded.value = true;
});
</script>

<template>
    <Sidebar :back="{ to: { name: 'dashboard' }, label: __('Retour au Dashboard') }">
        <div class="flex-none px-6">
            <PrimaryButton :as="AppLink" :to="{ name: 'one-click', force: true }" class="w-full" :z="1" :icon="MagicIcon">
                {{ __("Démarrer un nouveau chat") }}
            </PrimaryButton>
        </div>

        <div class="flex-grow overflow-y-auto flex flex-col mt-3">
            <div class="flex flex-col flex-1 divide-y divide-gray-300 dark:divide-gray-800">
                <div v-if="projects.length > 0" class="space-y-1.5">
                    <div
                        :class="['border-transparent',
                            'text-gray-900 dark:text-gray-200 group flex items-center gap-x-1.5 px-6 py-2 text-sm leading-6 border-l-2',
                        ]">
                        <div class="flex items-center gap-x-3">
                            <HistoryIcon class="size-5 shrink-0" aria-hidden="true" />
                            {{ __("Historique") }}
                        </div>
                    </div>

                    <div v-for="project in projects" :key="project.id">
                        <AppLink
                            :to="{ name: 'publications.index', params: { id: project.id } }"
                            :class="['hover:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:border-gray-700',
                                'border-transparent',
                                'text-gray-900 dark:text-gray-200 group flex items-center gap-x-1.5 px-6 py-2 text-sm leading-6 border-l-2',
                            ]">
                            <div class="truncate">
                                {{ project.name }}
                            </div>
                        </AppLink>
                    </div>

                    <div class="flex-none px-6">
                        <AppLink
                            :to="{ name: 'projects.index' }"
                            :class="['text-gray-900 hover:text-gray-700 hover:underline',
                                'dark:text-gray-200 dark:hover:text-white',
                                'group flex gap-x-3 rounded-md py-2 text-xs items-center font-semibold',
                            ]">
                            {{ __("Voir tous les projets") }}
                            <ArrowRightIcon class="w-5 h-5 shrink-0" aria-hidden="true" />
                        </AppLink>
                    </div>
                </div>
            </div>
        </div>
    </Sidebar>
</template>
